var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgSuccess = function SvgSuccess(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 53,
    viewBox: "0 0 53 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.8797 26.5006C52.8797 11.9605 41.0403 0.121094 26.5002 0.121094C11.96 0.121094 0.120605 11.9605 0.120605 26.5006C0.120605 41.0408 11.96 52.8802 26.5002 52.8802C41.0403 52.8802 52.8797 41.0408 52.8797 26.5006ZM2.77061 26.5006C2.77061 13.424 13.4235 2.77109 26.5002 2.77109C39.5768 2.77109 50.2297 13.424 50.2297 26.5006C50.2297 39.5773 39.5768 50.2302 26.5002 50.2302C13.4235 50.2302 2.77061 39.5773 2.77061 26.5006Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5119 18.8438L41.4337 20.6683L24.0532 38.9752L11.5664 25.8226L13.4883 23.998L24.0532 35.1264L39.5119 18.8438Z"
  })));
};
export default SvgSuccess;